module.exports = __webpack_public_path__ + "img/blog-14-1.d765c4b1.webp";